import { decode } from 'html-entities'
import React, { useMemo } from 'react'
import { PlainTextProps } from './types'

/**
 * Use this component for inserting Text with HTML Entities.
 */
export const PlainText = ({ children, as = 'span', ...props }: PlainTextProps): JSX.Element => {
  const Tag = as
  const unescaped = useMemo(() => (children && typeof children === 'string' ? decode(children) : children), [children])
   
  return <Tag {...(props as any)}>{unescaped}</Tag>
}
